import { ScatterplotLayer } from '@deck.gl/layers';
import { MapViewState } from '@deck.gl/core';
import { HouseholdGroup } from '../../../types/global';
import tailwindConfig from '../../../../tailwind.config';
import hexToRgb from '../../../shared/utils/colours';

const ringColour = hexToRgb(tailwindConfig.theme.extend.colors.pipblue.DEFAULT);

// Ring around the last selected household dot drawn above the neighboring dots
export default function selectionRingLayer(
  householdGroups: HouseholdGroup[],
  selectedCoordinates: HouseholdGroup['coordinates'] | null,
  viewState: MapViewState,
) {
  const zoom = viewState?.zoom ?? 8;
  const radiusScale = zoom < 10 ? 2 : 1;
  // Empty when the dot has been filtered out
  const selectedGroups = selectedCoordinates
    ? householdGroups.filter(({ coordinates }) => (
      coordinates.latitude === selectedCoordinates.latitude && coordinates.longitude === selectedCoordinates.longitude
    ))
    : [];

  return new ScatterplotLayer({
    id: 'selection-ring-layer',
    data: selectedGroups,
    getPosition: (d: HouseholdGroup) => [d.coordinates.longitude, d.coordinates.latitude],
    filled: false,
    stroked: true,
    getLineColor: ringColour,
    getLineWidth: 2,
    lineWidthUnits: 'pixels',
    getRadius: 5,
    radiusScale,
    radiusUnits: 'pixels',
    pickable: false,
  });
}
